
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/business-account",
      function () {
        return require("private-next-pages/sign-up/business-account/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-up/business-account"])
      });
    }
  